import { render, staticRenderFns } from "./Firmas.vue?vue&type=template&id=e1711116"
import script from "./Firmas.vue?vue&type=script&lang=js"
export * from "./Firmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports